/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { AxiosPromise } from 'axios';
import {
  PaymentTokenResponse,
  ValidatePaymentResponse,
} from 'Models/Applications/ValidatePayment';
import fetchHTTP from 'Utils/fetchHTTP';

export type ValidPaymentPayload = { payment_id: string } | { payment_intent_id: string };

type ValidPaymentFetchPayload = {
  data: ValidPaymentPayload;
  headers ?: {
    'X-Signature': string;
  };
  method: string;
};

const paymentToken = (payment_intent_id: string) => fetchHTTP(
  `/v1/public/token?payment_intent_id=${payment_intent_id}`,
  { method: 'GET' },
) as AxiosPromise<PaymentTokenResponse>;

const validPayment = (data: ValidPaymentPayload, signature?: string) => {
  const payload: ValidPaymentFetchPayload = {
    data,
    method: 'POST',
  };

  if (signature) {
    payload.headers = {
      'X-Signature': signature,
    };
  }

  return fetchHTTP('/v1/public/validate_payment', payload) as AxiosPromise<ValidatePaymentResponse>;
};

const infoPayment = (data: Record<string, string>) => fetchHTTP('/v1/protected/payments', {
  data,
  method: 'POST',
}) as AxiosPromise<any>;

const getTokenForPurchase = () => fetchHTTP('/v1/protected/consumer/payments/validate', {
  method: 'GET',
}) as AxiosPromise<any>;

export default validPayment;

export {
  getTokenForPurchase,
  infoPayment,
  paymentToken,
  validPayment,
};
